import { ActionContext } from 'vuex'
import API from '@/utils/API'

export const GIFT_CARD_DIALOG_INDEX = {
  ISSUE_CONFIRM: 0,
  POINT_ERROR: 1,
  ISSUE_API_ERROR: 2,
  ISSUE_API_OK: 3,
  ISSUE_API_POSTING: 4,
}

export const GIFT_CARD_BRAND = {
  NOTHING: 0,
  GOOGLE: 1,
  APPLE: 2,
  AMAZON: 3,
}

export const GIFT_CARD_STATE = {
  AVAILABLE: 1,
  NOT_AVAILABLE: 2,
  ALREADY_ISSUE: 3,
}

const state = {
  isActive: false,
  dialogSetIndex: 0,
  giftCardId: 0,
  giftCardBrand: 0,
}

type State = typeof state
type ModuleActionContext = ActionContext<State, {}>

const getters = {
  dialogSetTitle: (state: State) => {
    switch (state.dialogSetIndex) {
      case GIFT_CARD_DIALOG_INDEX.ISSUE_CONFIRM:
      case GIFT_CARD_DIALOG_INDEX.ISSUE_API_POSTING:
        return '確認'
      case GIFT_CARD_DIALOG_INDEX.POINT_ERROR:
        return 'エラー'
      default:
        return null
    }
  },
  dialogSetMessage: (state: State) => {
    switch (state.giftCardBrand) {
      case GIFT_CARD_BRAND.GOOGLE:
        return '3,000LIVEポイントをGooglePlayギフトコード（2,500円分）と交換しますか？'
      case GIFT_CARD_BRAND.APPLE:
        return '3,000LIVEポイントをApp Store & iTunes ギフトカード（デジタルギフトコード）（2,500円分）と交換しますか？'
      case GIFT_CARD_BRAND.AMAZON:
        return '3,000LIVEポイントをAmazonギフト券（2,500円分）と交換しますか？'
      default:
        return null
    }
  },
  canSubmitDialog: (state: State) => {
    return state.dialogSetIndex != GIFT_CARD_DIALOG_INDEX.ISSUE_API_POSTING
  },
}

const actions = {
  showGiftCardDialog: function (
    { commit }: ModuleActionContext,
    giftCardId: number
  ) {
    commit('setIsActive', true)
    commit('setDialogSetIndex', GIFT_CARD_DIALOG_INDEX.ISSUE_CONFIRM)
    commit('setGiftCardId', giftCardId)
  },
  showGiftCardNoPointDialog: function ({ commit }: ModuleActionContext) {
    commit('setIsActive', true)
    commit('setDialogSetIndex', GIFT_CARD_DIALOG_INDEX.POINT_ERROR)
  },
  showGiftCardApiErrorDialog: function ({ commit }: ModuleActionContext) {
    commit('setIsActive', true)
    commit('setDialogSetIndex', GIFT_CARD_DIALOG_INDEX.ISSUE_API_ERROR)
  },

  selectCardBrand: function (
    { commit }: ModuleActionContext,
    giftCardBrand: number
  ) {
    commit('setGiftCardBrand', giftCardBrand)
  },
  closeGiftCardDialog: function ({ commit }: ModuleActionContext) {
    commit('setIsActive', false)
  },
  async postIssueGiftCard({ commit, state }: ModuleActionContext) {
    commit('setDialogSetIndex', GIFT_CARD_DIALOG_INDEX.ISSUE_API_POSTING)
    const params = {
      giftCardId: state.giftCardId,
    }
    const request = API.Request.giftCardIssue(params)
    const response = await API.load(request)
    if (response.giftCardUrl.length > 0) {
      commit('setDialogSetIndex', GIFT_CARD_DIALOG_INDEX.ISSUE_API_OK)
      commit('setGiftCardBrand', response.GiftCardBrand)
    }
  },
}

const mutations = {
  setIsActive(state: State, isActive: boolean) {
    state.isActive = isActive
  },
  setDialogSetIndex(state: State, dialogSetIndex: number) {
    state.dialogSetIndex = dialogSetIndex
  },
  setGiftCardId(state: State, giftCardId: number) {
    state.giftCardId = giftCardId
  },
  setGiftCardBrand(state: State, giftCardBrand: number) {
    state.giftCardBrand = giftCardBrand
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
